export const cacheKeys = {
  getEvent: 'getEvent',
  getEvents: 'getEvents',
  getUserEvents: 'getUserEvents',
  createEvent: 'createEvent',
  editEvent: 'editEvent',
  deleteEvent: 'deleteEvent',
};
